export const api = (uri: string, cluster?: string) => {
  const clusterWithDot = cluster ? `.${cluster}` : ''
  return `https://api${clusterWithDot}.${process.env.CHILIPIPER_API_DOMAIN}${uri}`
}

export const tenantApi = (tenantDomain: string, uri: string) => {
  // return `http://chilipiper.team:4004${uri}`
  return `https://${tenantDomain}.${process.env.CHILIPIPER_API_DOMAIN}${uri}`
}
